var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("div", { staticClass: "flex" }, [
              _c(
                "div",
                [
                  _vm.cardId
                    ? _c("div", [
                        _c("label", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.cardSearchOnly,
                                expression: "cardSearchOnly",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.cardSearchOnly)
                                ? _vm._i(_vm.cardSearchOnly, null) > -1
                                : _vm.cardSearchOnly,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.cardSearchOnly,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.cardSearchOnly = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.cardSearchOnly = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.cardSearchOnly = $$c
                                  }
                                },
                                () => _vm.gerRecords(1),
                              ],
                            },
                          }),
                          _vm._v(
                            "\n              Искать только СМС по карте заявки"
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.cardSearchOnly
                    ? [
                        _c(
                          "div",
                          { staticClass: "mb-2" },
                          [
                            _c("label", [_vm._v("Выберите получателя")]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.searchFilter.receivers,
                              function (alias, r) {
                                return _c(
                                  "div",
                                  { staticClass: "form-group mb-0" },
                                  [
                                    _c("label", { staticClass: "mb-0" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.selectedFilter.receiver,
                                            expression:
                                              "selectedFilter.receiver",
                                          },
                                        ],
                                        attrs: { type: "radio" },
                                        domProps: {
                                          value: r,
                                          checked: _vm._q(
                                            _vm.selectedFilter.receiver,
                                            r
                                          ),
                                        },
                                        on: {
                                          change: [
                                            function ($event) {
                                              return _vm.$set(
                                                _vm.selectedFilter,
                                                "receiver",
                                                r
                                              )
                                            },
                                            () => _vm.gerRecords(1),
                                          ],
                                        },
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(alias) +
                                          "\n                "
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "обновить список",
                      className: "btn btn-outline-success btn-xs",
                      onClick: () => _vm.gerRecords(1),
                      loading: _vm.loading,
                      color: _vm.$constants.SUCCESS_COLOR,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex justify-content-between" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Выберите типы сообщений")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedFilter.type,
                        expression: "selectedFilter.type",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.selectedFilter,
                            "type",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        () => _vm.gerRecords(1),
                      ],
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("Все сообщения"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "optgroup",
                      { attrs: { label: "---" } },
                      _vm._l(_vm.searchFilter.types, function (t) {
                        return _c("option", { domProps: { value: t.type } }, [
                          _vm._v(_vm._s(t.title)),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  [
                    _vm._v("Проверка поступлений\n            "),
                    _vm.selectedQiwi?.id
                      ? [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.printCustomDate(
                                  _vm.selectedQiwi.balance_date,
                                  !!_vm.selectedQiwi.phone_id
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: `/storage/balance/balance_${
                                  _vm.selectedQiwi.id
                                }.png?t=${Date.now()}`,
                              },
                            },
                            [_vm._v("screen")]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedQiwi,
                        expression: "selectedQiwi",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedQiwi = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { disabled: "", value: "0" } }, [
                      _vm._v("Выберите кошелек"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.qiwiCards, function (card, id) {
                      return _c("option", { domProps: { value: card } }, [
                        _vm._v(
                          "[" + _vm._s(card.id) + "] " + _vm._s(card.number)
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("pulse-loader", {
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                color: _vm.$constants.LOADING_COLOR,
              },
            }),
            _vm._v(" "),
            !_vm.loading && _vm.records
              ? [
                  _c(
                    "table",
                    { staticClass: "table table-sm mt-1 table-hover" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.records, function (r, i) {
                          return _c(
                            "tr",
                            {
                              class: {
                                disabled: !r.isActive,
                                selected:
                                  r.id ===
                                  (_vm.selectedCard && _vm.selectedCard.id),
                              },
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    i +
                                      1 +
                                      (_vm.paginator.current_page - 1) *
                                        _vm.paginator.per_page
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.id))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "(" +
                                    _vm._s(r?.card?.id) +
                                    ") " +
                                    _vm._s(r?.card?.number)
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  (!r.order_id && _vm.orderId) ||
                                  _vm.onPairRecord
                                    ? [
                                        r.isActive
                                          ? _c("LoadingButton", {
                                              attrs: {
                                                title: "привязать к заявке",
                                                className:
                                                  "btn btn-outline-success btn-xs",
                                                onClick: () =>
                                                  _vm.updateRecord(
                                                    r.id,
                                                    "addToOrder"
                                                  ),
                                                loading: _vm.loadingBtn[r.id],
                                                color:
                                                  _vm.$constants.SUCCESS_COLOR,
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    : [
                                        !_vm.noSearchOrders
                                          ? [
                                              _c("LoadingButton", {
                                                attrs: {
                                                  title: "поиск заявки",
                                                  className:
                                                    "btn btn-outline-success btn-xs",
                                                  onClick: () =>
                                                    _vm.getOrders(r),
                                                  loading: _vm.loadingBtn[r.id],
                                                  color:
                                                    _vm.$constants
                                                      .SUCCESS_COLOR,
                                                },
                                              }),
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(r.order_id) +
                                                  "\n                "
                                              ),
                                            ],
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.sum))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "fs-12" }, [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.formatMessage(r.message)
                                    ),
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.printCustomDate(r.date, !!r.phone_id)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.allowToRemove(r)
                                    ? _c(
                                        "v-popover",
                                        {
                                          attrs: {
                                            "auto-hide": true,
                                            open: _vm.openDeleteTooltip[r.id],
                                          },
                                          on: {
                                            hide: () =>
                                              (_vm.openDeleteTooltip[
                                                r.id
                                              ] = false),
                                          },
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-outline-danger btn-xs",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.createDeleteTooltip(
                                                    r.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("удалить")]
                                          ),
                                          _vm._v(" "),
                                          _c("template", { slot: "popover" }, [
                                            _c("p", [
                                              _vm._v(
                                                "Действительно хотите удалить запись?"
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex justify-content-between",
                                              },
                                              [
                                                r.isActive
                                                  ? _c("LoadingButton", {
                                                      attrs: {
                                                        title: "подтвердить",
                                                        className:
                                                          "btn btn-outline-danger btn-xs",
                                                        onClick: () =>
                                                          _vm.updateRecord(
                                                            r.id,
                                                            "deactivate"
                                                          ),
                                                        loading:
                                                          _vm.loadingBtn[r.id],
                                                        color:
                                                          _vm.$constants
                                                            .LOADING_COLOR,
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-default btn-xs",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.openDeleteTooltip[
                                                          r.id
                                                        ] = false
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("отмена")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.paginator
              ? _c("paginate", {
                  attrs: {
                    "page-count": _vm.paginator.last_page,
                    "page-range": 8,
                    "margin-pages": 2,
                    "click-handler": _vm.gerRecords,
                    "prev-text": "&laquo",
                    "next-text": "&raquo",
                    "container-class": "pagination",
                    "prev-class": "page-item",
                    "prev-link-class": "page-link",
                    "page-class": "page-item",
                    "page-link-class": "page-link",
                    "next-class": "page-item",
                    "next-link-class": "page-link",
                    "active-class": "active green_btn",
                  },
                  model: {
                    value: _vm.paginator.current_page,
                    callback: function ($$v) {
                      _vm.$set(_vm.paginator, "current_page", $$v)
                    },
                    expression: "paginator.current_page",
                  },
                })
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      !_vm.noSearchOrders && _vm.selectedCard
        ? [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("pulse-loader", {
                    staticClass: "text-center",
                    attrs: {
                      loading: _vm.loadingOrders,
                      color: _vm.$constants.LOADING_COLOR,
                    },
                  }),
                  _vm._v(" "),
                  !_vm.loadingOrders
                    ? [
                        _c("div", { staticClass: "p-2 border mb-2" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Комментарий к оплате"),
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.comment,
                                  expression: "comment",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                required: "",
                                placeholder: "детали оплаты",
                              },
                              domProps: { value: _vm.comment },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.comment = $event.target.value
                                },
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-2" },
                            [_c("UploadImages", { ref: "images" })],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.closeOrders.length
                          ? [
                              _c("h5", [_vm._v("Подходящие заявки")]),
                              _vm._v(" "),
                              _c("OrdersList", {
                                attrs: {
                                  orders: _vm.closeOrders,
                                  compareSum: _vm.messageSum,
                                  comment: _vm.comment,
                                  selectedCard: _vm.selectedCard,
                                },
                              }),
                              _vm._v(" "),
                              _c("hr"),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.orders.length
                          ? _c("OrdersList", {
                              attrs: {
                                orders: _vm.orders,
                                comment: _vm.comment,
                                selectedCard: _vm.selectedCard,
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.confirmedOrders && _vm.confirmedOrders.length
                          ? [
                              _c("hr"),
                              _vm._v(" "),
                              _c("h5", [_vm._v("Подтвержденные предоплаты")]),
                              _vm._v(" "),
                              _c("OrdersList", {
                                attrs: {
                                  orders: _vm.confirmedOrders,
                                  comment: _vm.comment,
                                  selectedCard: _vm.selectedCard,
                                },
                              }),
                            ]
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pl-2 pr-2" }, [
      _c("div", { staticClass: "alert alert-info mb-0" }, [
        _c("p", [
          _vm._v(
            "Кнопка поиск заявок - ищет все заявки, на которые были отправлены реквизиты с этой картой"
          ),
        ]),
        _vm._v(" "),
        _c("p", [_vm._v("Вверху заявки, к которым не привязана оплата")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Внизу отдельно заявки, к которым оплата привязана за последние 10 дней (это удобно для привязки\n              второй SMS - при дублях или при оплате в несколько частей)"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("карта")]),
        _vm._v(" "),
        _c("th", [_vm._v("Заявка")]),
        _vm._v(" "),
        _c("th", [_vm._v("сумма")]),
        _vm._v(" "),
        _c("th", [_vm._v("Сообщение")]),
        _vm._v(" "),
        _c("th", [_vm._v("Дата")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }